import { useState, useEffect, useCallback } from 'react';
import { Button, Popup, TextBox } from 'devextreme-react';
import './CountertopUniversityCertificationPopup.scss';
import { useCountertopUniversity } from '../contexts/countertopUniversityContext';
import GraduationCap from '../../../../assets/images/graduation-cap-solid.svg';
import CountertopUniversityCertificateViewer from './CountertopUniversityCertificateViewer';
import { LoadPopupPanel } from '../../../../components';
import { useGenerateCountertopUniversityCertificate } from '../api/generate-countertop-university-certificate';
import Validator, { EmailRule, RequiredRule } from "devextreme-react/validator";
import { showErrorMessage } from '../../../../utils/messages';

const CountertopUniversityCertificationPopup = () => {
    const context = useCountertopUniversity();
    const [fullName, setFullName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [certFileData, setCertFileData] = useState<{ certUrl: string; email: string; completedDate: Date; }>();
    const [generateCertificate, setGenerateCertificate] = useState(false);

    const handleFullNameChange = (e: any) => {
        setFullName(e.value);
    };

    const handleEmailChange = (e: any) => {
        setEmail(e.value);
    };

    const handleCancel = () => {
        context.setCertificationPopupVisible(false);
    };

    const handleSuccess = useCallback((data: any) => {
        const certData = {
            certUrl: data.certUrl,
            email: data.email,
            completedDate: data.completedDate
        };
        setCertFileData(certData);
        setGenerateCertificate(true);
        context.setCertificateViewerPopupVisible(true);
    }, [context]);

    const handleError = useCallback((error: string) => {
        showErrorMessage(error);
        setGenerateCertificate(false);
        context.setCertificationPopupVisible(false);
    }, [context]);

    const { mutate: certFileMutate, isLoading } = useGenerateCountertopUniversityCertificate(
        fullName,
        email,
        handleSuccess,
        handleError
    );

    const handleContinue = async (e: any) => {
        let validation = e.validationGroup.validate();
        if (validation.isValid) {
            certFileMutate();
        }
    };

    return (
        <>
            <Popup
                visible={context.certificationPopupVisible}
                title="Completion Certificate"
                width={800}
                height={410} 
                onHiding={handleCancel}
            >
                <div>

                    <div>
                        <div className='certification-header-container'>
                            <span className={'certification-gradiuation-container'}><img src={GraduationCap} /></span>
                            <span>
                                <p className="certification-header-info">Congratulations on completing the {context.courseTitle} training course in Sage Solutions Institute! You are one step closer to becoming a Surface Genius!</p>
                                <p className="certification-header-info"> To award you your certificate of completion, please provide the following information:</p>
                            </span>
                        </div>

                        <div className='certification-input-container' >
                            <div className="label-control-info">Full Name</div>
                            <div>
                                <TextBox
                                    placeholder="Full Name"
                                    value={fullName}
                                    onValueChanged={(e) => {
                                        handleFullNameChange(e);
                                    }}

                                >
                                    <Validator validationGroup="certificationGroup">
                                        <RequiredRule message="Full Name is required" />
                                    </Validator>

                                </TextBox>
                            </div>
                        </div>

                        <div className='certification-input-container'>
                            <div className="certification-label-control-info">Email</div>
                            <div>
                                <TextBox
                                    placeholder="Email"
                                    value={email}
                                    onValueChanged={(e) => {
                                        handleEmailChange(e);
                                    }}

                                >
                                    <Validator validationGroup="certificationGroup">
                                        <RequiredRule message="Email is required" />
                                        <EmailRule message="Email is invalid" />
                                    </Validator>
                                </TextBox>
                            </div>
                        </div>
                    </div>

                    <div className="certification-button-container">
                        <Button
                            validationGroup="certificationGroup"
                            text={'Get Certificate'}
                            type="default"
                            onClick={handleContinue}
                        />
                        <Button
                            text={'Cancel'}
                            type="danger"
                            onClick={handleCancel}
                        />
                    </div>
                </div>
                <LoadPopupPanel visible={isLoading}></LoadPopupPanel>
            </Popup>

            {certFileData && certFileData.certUrl && certFileData.email && (
                <CountertopUniversityCertificateViewer
                    fullName={fullName}
                    email={certFileData.email}
                    certUrl={certFileData.certUrl}
                    completedDate={certFileData.completedDate}
                />
            )}
        </>
    );
};

export default CountertopUniversityCertificationPopup;